import type { HttpPost } from '@/shared/infra/http'
import type { RevokeImpersonation } from '@/modules/auth/use-cases'

export class EdgeRevokeImpersonationRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: RevokeImpersonation = async () => {
    await this.httpClient.post<Record<string, never>, unknown>({
      url: '/internal-admin/impersonation/revoke',
      body: {},
    })
  }
}
